import { AutocompleteInput, useGetList, Validator } from 'react-admin';
import { useState, useMemo } from 'react';

interface OrganizationAutocompleteProps {
    alwaysOn?: boolean;
    required?: boolean;
    validate?: Validator | Validator[];
    onChange?: (value: any) => void;
    [key: string]: any;
}

export const OrganizationAutocomplete = (props: OrganizationAutocompleteProps) => {
    const { validate, required: isRequired, ...restProps } = props;
    const [searchText, setSearchText] = useState('');
    const [selectedItem, setSelectedItem] = useState<any>(null);

    const { data, isLoading } = useGetList(
        'organizations',
        {
            pagination: { page: 1, perPage: 50 },
            sort: { field: 'created_at', order: 'DESC' },
            filter: searchText ? { name: searchText, deleted: false } : { deleted: false },
        },
        {
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
        },
    );

    const choices = useMemo(() => {
        const dataArray = data || [];
        if (selectedItem && !dataArray.find((item: any) => item.id === selectedItem.id)) {
            return [selectedItem, ...dataArray];
        }
        return dataArray;
    }, [data, selectedItem]);

    const validationRules = useMemo(() => {
        const rules = [];
        if (validate) {
            rules.push(...(Array.isArray(validate) ? validate : [validate]));
        }
        return rules.length > 0 ? rules : undefined;
    }, [validate]);

    return (
        <AutocompleteInput
            {...restProps}
            source="organizationId"
            fullWidth
            label="Organization"
            choices={choices}
            optionText="name"
            optionValue="id"
            loading={isLoading}
            validate={validationRules}
            setFilter={value => setSearchText(value)}
            onChange={value => {
                const selected = choices.find((item: any) => item.id === value);
                if (selected) {
                    setSelectedItem(selected);
                }
                if (props.onChange) {
                    props.onChange(value);
                }
            }}
            debounce={500}
            shouldRenderSuggestions={(val: string) => {
                return val.trim().length >= 0;
            }}
        />
    );
};
